import { useListAccountCodes } from '@givebacks/api/compliance';

import { useCreateSearchFn } from '../../../../molecules/inputs/SearchableInputs/hooks';
import { SearchableSelectSearch } from '../../../../molecules/inputs/SearchableInputs/types';

const useFetchAccountCodesFromSelect = (
  searches: SearchableSelectSearch,
  { causeId }: { causeId: string }
) => {
  return useListAccountCodes({
    queryOptions: {
      join: 'OR',
      searches: searches,
    },
    pagination: {
      limit: 20,
    },
    causeId,
  });
};

/** Search Account codes by name given a causeId */
const useSearchAccountCodesFun = (causeId: string) =>
  useCreateSearchFn({
    useSearchFn: useFetchAccountCodesFromSelect,
    select: (data) =>
      data?.account_codes.map(({ code, uuid, name }) => ({
        label: name,
        value: uuid,
        code,
      })),
    params: { causeId },
    searchFields: ['name', 'code'],
  });

export { useSearchAccountCodesFun };
